import { render, staticRenderFns } from "./sunthree.vue?vue&type=template&id=3d648b48&scoped=true"
import script from "./sunthree.vue?vue&type=script&lang=js"
export * from "./sunthree.vue?vue&type=script&lang=js"
import style0 from "./sunthree.vue?vue&type=style&index=0&id=3d648b48&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d648b48",
  null
  
)

export default component.exports